import React from "react"
import useFormField from "../../../../hooks/useFormField"
import FormFieldError from "../labels/form-field-error"
import FormInputLabel from "../labels/form-field-label"
import ToggleInfo from "../buttons/toggle-info-button"

export default function NumberInput({
  name,
  id,
  label,
  placeholder,
  required,
  description,
  predefinedValue = "",
  validators = [],
  validateField,
  globalValue,
  setGlobalValue,
  setError,
  error,
  displayOption,
  closeModalLabel,
  moreInfoLabel,
}) {
  const { value, isFocused, handleFocus, handleBlur, handleChange } = useFormField(
    predefinedValue,
    validateField,
    globalValue,
    setGlobalValue,
    setError,
  )

  return (
    <div
      className={`form-element form-element--text form-element--number is-bound Form__Element ${displayOption} ${required ? "is-required " : ""} 
      ${isFocused ? "has-focus" : ""} ${isFocused || value ? "is-filled" : ""}  ${error ? "is-invalid" : ""}`}
      data-f-element-name={name}
      data-f-type="textbox"
    >
      <div className="form-labels">
        <FormInputLabel id={id} label={label} required={required} />
        <ToggleInfo description={description} id={id} closeModalLabel={closeModalLabel} moreInfoLabel={moreInfoLabel} />
      </div>
      <input
        name={name}
        id={id}
        type="number"
        className="form-input"
        required={required}
        aria-required={required}
        data-f-datainput=""
        value={value}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        aria-describedby={`${name}_desc`}
        min={validators.some((v) => v.type === "EPiServer.Forms.Implementation.Validation.PositiveIntegerValidator") ? "0" : undefined}
        title={description}
        aria-label={description + (placeholder != null ? " " + placeholder : "")}
        aria-invalid={!!error}
      />
      <FormFieldError name={name} error={error} placeholder={placeholder} />
    </div>
  )
}
